import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logoImage from './whitelogo.png'; // เปลี่ยนพาธให้ตรงกับไฟล์โลโก้ของคุณ
import './App.css'; // ตรวจสอบให้ CSS ถูกโหลด

function ServicesSection() {
  return (
    <section id="services">
      <Container>
        <Row className="justify-content-center">
          {/* โลโก้ */}
          <Col xs={12} md={4} className="text-center mb-4">
            <img src={logoImage} alt="Heart Clinic Logo" className="img-fluid" />
          </Col>
          {/* ข้อความ */}
          <Col xs={12} md={8}>
            <div className="content-box">
              <h2>บริการของเรา</h2>
              <p>
                ให้บริการตรวจรักษาดูแล <strong>โรคหัวใจ</strong> และ <strong>โรคทางอายุรกรรม</strong>
              </p>
              <ul>
                <li>ตรวจค้นสาเหตุของ อาการเจ็บแน่นหน้าอก จุกลิ้นปี่ หอบเหนื่อย เหนื่อยง่าย หายใจไม่อิ่ม วูบ หมดสติ ใจสั่น</li>
                <li>ตรวจวินิจฉัยเพิ่มเติมด้วยคลื่นไฟฟ้าหัวใจ (Electrocardiography - ECG)</li>
                <li>ตรวจวินิจฉัยเพิ่มเติมด้วยอัลตราซาวน์หัวใจ หรือ เอคโค่หัวใจ (Echocardiography)</li>
                <li>รักษาโรคหัวใจ ได้แก่ หัวใจโต หัวใจวาย น้ำท่วมปอด กล้ามเนื้อหัวใจขาดเลือด หลอดเลือดหัวใจตีบ ลิ้นหัวใจตีบหรือรั่ว เยื่อหุ้มหัวใจอักเสบ หัวใจเต้นผิดจังหวะ</li>
                <li>รักษาโรคทางอายุรกรรม ได้แก่ เบาหวาน ความดันโลหิตสูง ไขมันในเลือดสูง เกาต์ กรดไหลย้อน โรคกระเพาะอาหาร</li>
                <li>วัคซีนผู้สูงอายุ ได้แก่ ไข้หวัดใหญ่ 4 สายพันธุ์, ปอดอักเสบ</li>
                <li>ให้คำปรึกษาเพื่อลดน้ำหนักตัว และวัดองค์ประกอบร่างกาย(body composition)</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ServicesSection;
